import { useCallback } from 'react';

import { Input } from '@/components/Form/Input/Input';

import type { InputProps } from '@/components/Form/Input/Input';

interface BookerInputProps<Key = string> extends InputProps {
  handleValue: (key: Key, value: string) => void;
  fieldKey: Key;
}

export function TypedInput({ handleValue, fieldKey, ...props }: BookerInputProps) {
  const onChange = useCallback(
    (value: string) => {
      handleValue(fieldKey, value);
    },
    [handleValue, fieldKey],
  );

  return <Input onValueChange={onChange} key={fieldKey} {...props} />;
}
